/* ==========================================================================
   VALETTO 카트 드로어 — 부가 기능
   - 당일출고 마감 카운트다운 + 도착 예정일
   - 조건부 사은품 자동 담기/빼기 (화면은 항상 서버 반영 후 갱신)
   - 할인코드 적용/삭제
   - 테마의 cart-drawer.js 가 없을 때를 위한 최소 fallback 엘리먼트
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION_ID = 'valetto-cart-drawer'; // header-group.json 의 섹션 키와 동일해야 함
  var SECTIONS = [SECTION_ID, 'cart-icon-bubble'];
  var GIFT_PROP = '_valetto_gift';

  /* ---------- 유틸 ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function drawer() { return $('cart-drawer'); }
  function panel() { return $('cart-drawer .vcd__state'); }
  function inner() { return $('cart-drawer .drawer__inner'); }

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  /* 섹션 HTML(JSON)로 드로어 + 헤더 카트 아이콘 갱신 */
  function renderSections(sections) {
    var d = drawer();
    if (!d || !sections) return;
    var inner = $('.drawer__inner', d);
    if (inner && sections[SECTION_ID]) {
      inner.innerHTML = sectionInner(sections[SECTION_ID], '.drawer__inner');
      var fresh = $('.drawer__inner', d);
      d.classList.toggle('is-empty', !!(fresh && fresh.classList.contains('is-empty')));
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
    }
    document.dispatchEvent(new CustomEvent('vcd:refreshed'));
  }

  /* 섹션 렌더링 API로 드로어 + 헤더 카트 아이콘 갱신 */
  function refreshDrawer(openAfter) {
    return fetch(ROOT + '?sections=' + SECTIONS.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        renderSections(sections);
        var d = drawer();
        if (d && openAfter && typeof d.open === 'function' && !d.classList.contains('active')) d.open();
      })
      .catch(function (e) { console.warn('[vcd] refresh failed', e); });
  }

  /* ---------- 1. 당일출고 / 도착 예정 ---------- */
  var KO_DAYS = ['일', '월', '화', '수', '목', '금', '토'];
  var etaTimer = null;

  function parseHolidays(str) {
    var set = {};
    (str || '').split(',').forEach(function (s) { s = s.trim(); if (s) set[s] = true; });
    return set;
  }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function isShipDay(d, holidays, everyDay) {
    if (everyDay) return true;
    var day = d.getDay();
    return day !== 0 && day !== 6 && !holidays[ymd(d)];
  }
  function addShipDays(from, n, holidays, everyDay) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isShipDay(d, holidays, everyDay)) n--;
    }
    return d;
  }
  function fmtKoDate(d, now) {
    // 내일 도착이면 날짜 대신 '내일(요일)' 로 표시
    if (now) {
      var base = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      if (Math.round((target - base) / 86400000) === 1) return '내일(' + KO_DAYS[d.getDay()] + ')';
    }
    return (d.getMonth() + 1) + '월 ' + d.getDate() + '일(' + KO_DAYS[d.getDay()] + ')';
  }
  function fmtRemaining(ms) {
    var totalMin = Math.max(0, Math.floor(ms / 60000));
    var h = Math.floor(totalMin / 60), m = totalMin % 60;
    if (h > 0) return h + '시간 ' + m + '분';
    return m + '분';
  }
  // 마감일 표시: 오늘 / 내일 / M월 D일(요일)
  function fmtCutoffDay(d, now) {
    var base = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var diff = Math.round((target - base) / 86400000);
    if (diff === 0) return '오늘';
    if (diff === 1) return '내일';
    return (d.getMonth() + 1) + '월 ' + d.getDate() + '일(' + KO_DAYS[d.getDay()] + ')';
  }
  // 마감 시각 표시: 오전 10시 / 오후 2시 30분
  function fmtClock(h, m) {
    var ap = h < 12 ? '오전' : '오후';
    var hh = h % 12;
    if (hh === 0) hh = 12;
    return ap + ' ' + hh + '시' + (m ? ' ' + m + '분' : '');
  }
  var URGENT_MS = 3 * 60 * 60 * 1000; // 마감 3시간 전부터 카운트다운

  var lastEtaHtml = '';
  function renderEta() {
    var box = $('[data-vcd-eta]');
    if (!box) return;
    var textEl = $('[data-vcd-eta-text]', box);
    var cutoff = (box.dataset.cutoff || '10:00').split(':');
    var cutH = parseInt(cutoff[0], 10) || 0, cutM = parseInt(cutoff[1], 10) || 0;
    var lead = parseInt(box.dataset.leadDays, 10) || 1;
    var everyDay = box.dataset.everyDay === 'true';
    var holidays = parseHolidays(box.dataset.holidays);

    // 다음 출고 마감 시각: 오늘 마감 전이면 오늘, 아니면 다음 출고일의 마감 시각
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var shipDate = today;
    var cutoffAt = new Date(today.getFullYear(), today.getMonth(), today.getDate(), cutH, cutM, 0, 0);
    if (!isShipDay(today, holidays, everyDay) || now >= cutoffAt) {
      shipDate = addShipDays(today, 1, holidays, everyDay);
      cutoffAt = new Date(shipDate.getFullYear(), shipDate.getMonth(), shipDate.getDate(), cutH, cutM, 0, 0);
    }
    var eta = addShipDays(shipDate, lead, holidays, everyDay);

    // 1줄: 도착 날짜(굵게) / 2줄: 주문 조건(작은 회색)
    // 마감까지 3시간 미만이면 카운트다운, 그 외에는 '오늘/내일 오전 10시까지'
    var remain = cutoffAt - now;
    var cond;
    if (remain < URGENT_MS) {
      cond = '<strong>' + fmtRemaining(remain) + '</strong> 안에 주문 시';
    } else {
      cond = fmtCutoffDay(cutoffAt, now) + ' ' + fmtClock(cutH, cutM) + '까지 주문 시';
    }
    var html = '<span class="vcd__eta-date">' + fmtKoDate(eta, now) + ' 도착 예정</span>' +
      '<span class="vcd__eta-cond">' + cond + '</span>';
    if (textEl && html !== lastEtaHtml) {
      lastEtaHtml = html;
      textEl.innerHTML = html;
    } else if (textEl && textEl.innerHTML !== html) {
      textEl.innerHTML = html;
    }
  }
  function startEta() {
    renderEta();
    if (etaTimer) clearInterval(etaTimer);
    etaTimer = setInterval(renderEta, 60000);
  }

  /* ---------- 2. 조건부 사은품 ---------- */
  var giftBusy = false;
  function syncGift() {
    var p = panel();
    if (!p || giftBusy) return;
    if (p.dataset.vcdGiftEnabled !== 'true') return;
    var variant = p.dataset.vcdGiftVariant;
    if (!variant) return;
    var reached = p.dataset.vcdGiftReached === 'true';
    var inCart = p.dataset.vcdGiftInCart === 'true';
    var lineKey = p.dataset.vcdGiftLineKey;

    if (reached && !inCart) {
      giftBusy = true;
      var props = {}; props[GIFT_PROP] = 'true';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1, properties: props }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('gift add failed'); })
        .then(function () { return refreshDrawer(false); })
        .catch(function (e) { console.warn('[vcd] gift add', e); })
        .then(function () { giftBusy = false; });
    } else if (!reached && inCart && lineKey) {
      giftBusy = true;
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function () { return refreshDrawer(false); })
        .catch(function (e) { console.warn('[vcd] gift remove', e); })
        .then(function () { giftBusy = false; });
    }
  }

  /* ---------- 3. 할인코드 ---------- */
  var MSG_OK = '할인코드가 적용됐어요';
  var MSG_BAD = '사용할 수 없는 할인코드예요';
  var MSG_FAIL = '할인코드를 적용하지 못했어요. 다시 시도해 주세요.';

  function currentCodes() {
    return $$('[data-vcd-code]').map(function (el) { return el.dataset.vcdCode; }).filter(Boolean);
  }
  function setDiscountMsg(text, ok) {
    var m = $('[data-vcd-discount-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-ok', !!ok);
  }
  function applyCodes(codes, added, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status && state.status >= 400) throw new Error(state.description || 'error');
        // 구버전 API(할인코드 미지원) 대비: /discount/ 경로로 적용 후 새로고침
        if (!state || !Array.isArray(state.discount_codes)) {
          if (!added) return refreshDrawer(false);
          return fetch(ROOT + 'discount/' + encodeURIComponent(added)).then(function () { return refreshDrawer(false); }).then(function () {
            var ok = currentCodes().some(function (c) { return c.toLowerCase() === added.toLowerCase(); });
            setDiscountMsg(ok ? MSG_OK : MSG_BAD, ok);
          });
        }
        renderSections(state.sections);
        if (added) {
          var hit = null;
          state.discount_codes.forEach(function (c) { if (String(c.code).toLowerCase() === added.toLowerCase()) hit = c; });
          if (hit && hit.applicable) setDiscountMsg(MSG_OK, true);
          else {
            setDiscountMsg(MSG_BAD, false);
            var inp = $('[data-vcd-discount-input]');
            if (inp) inp.value = added;
          }
        }
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        setDiscountMsg(MSG_FAIL, false);
      });
  }
  function onDiscountApply() {
    var inp = $('[data-vcd-discount-input]');
    var btn = $('[data-vcd-discount-apply]');
    var code = inp ? inp.value.trim() : '';
    if (!code) { setDiscountMsg('할인코드를 입력해 주세요', false); if (inp) inp.focus(); return; }
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    applyCodes(codes, code, btn);
  }
  function onDiscountRemove(code, btn) {
    var codes = currentCodes().filter(function (c) { return c !== code; });
    if (btn) btn.closest('.vcd__chip').style.opacity = '0.4';
    applyCodes(codes, null, null);
  }

  /* ---------- 4. 수량 변경: Shrine 의 300ms 디바운스만 건너뛰고 즉시 요청 (화면은 서버 반영 후 갱신) ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('vcd__qty-input')) return;
    var items = input.closest('cart-drawer-items');
    if (!items || typeof items.updateQuantity !== 'function') return;
    e.stopImmediatePropagation();
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    var name = (document.activeElement && document.activeElement.getAttribute) ? document.activeElement.getAttribute('name') : null;
    items.updateQuantity(input.dataset.index, qty, name);
  }, true);

  /* ---------- 초기화 / 재렌더 감지 ---------- */
  function init() {
    startEta();
    syncGift();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vcd-discount-apply]')) { e.preventDefault(); onDiscountApply(); return; }
    var rm = e.target.closest('[data-vcd-discount-remove]');
    if (rm) { e.preventDefault(); onDiscountRemove(rm.dataset.vcdDiscountRemove, rm); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-vcd-discount-input]')) {
      e.preventDefault();
      onDiscountApply();
    }
  });

  // 테마 JS가 .drawer__inner 를 통째로 갈아끼우므로 변화를 감지해 다시 초기화
  var debounce = null;
  function observe() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(function (records) {
      var relevant = false;
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.nodeType === 1 && t.closest && t.closest('[data-vcd-eta]')) continue; // 내가 쓴 도착 문구 갱신은 무시
        relevant = true; break;
      }
      if (!relevant) return;
      // 드로어가 새로 그려지면 도착 문구는 빈 칸으로 오므로, 화면에 그려지기 전에 바로 채운다 (깜빡임 방지)
      renderEta();
      clearTimeout(debounce);
      debounce = setTimeout(init, 80);
    }).observe(d, { childList: true, subtree: true });
  }

  /* ---------- fallback: 테마에 cart-drawer 엘리먼트가 없을 때 ---------- */
  function defineFallback() {
    if (customElements.get('cart-drawer')) return;
    console.info('[vcd] theme cart-drawer element not found — using fallback');
    class VcdCartDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('keyup', function (e) { if (e.code === 'Escape') this.close(); }.bind(this));
        var ov = this.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', this.close.bind(this));
        var icon = document.querySelector('#cart-icon-bubble');
        if (icon) icon.addEventListener('click', function (e) { e.preventDefault(); this.open(icon); }.bind(this));
      }
      open(triggered) {
        if (triggered) this.activeElement = triggered;
        this.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        var inner = this.querySelector('.drawer__inner');
        if (inner) inner.focus();
      }
      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        if (this.activeElement) this.activeElement.focus();
      }
      getSectionsToRender() {
        return [
          { id: SECTION_ID, section: SECTION_ID, selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];
      }
      renderContents(parsedState) {
        var self = this;
        this.getSectionsToRender().forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && parsedState.sections && parsedState.sections[s.id]) el.innerHTML = sectionInner(parsedState.sections[s.id], s.selector);
        });
        this.classList.remove('is-empty');
        setTimeout(function () {
          var ov = self.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', self.close.bind(self));
          self.open();
        });
      }
    }
    customElements.define('cart-drawer', VcdCartDrawer);
  }

  /* ---------- 테마 JS 패치: 섹션 이름을 새 섹션으로 교체 ----------
     Dawn/Shrine 의 cart-drawer.js 는 'cart-drawer' 섹션을 하드코딩해서 가져옵니다.
     새 섹션(valetto-cart-drawer)을 보도록 getSectionsToRender 를 덮어씁니다. */
  function patchThemeClasses() {
    var Drawer = customElements.get('cart-drawer');
    if (Drawer && !Drawer.prototype.__vcdPatched) {
      // Shrine 원본: [{id:'cart-drawer', selector:'#CartDrawer'}, {id:'cart-icon-bubble'}]
      Drawer.prototype.getSectionsToRender = function () {
        return [
          { id: SECTION_ID, selector: '#CartDrawer' },
          { id: 'cart-icon-bubble' }
        ];
      };
      Drawer.prototype.__vcdPatched = true;
    }
    var Items = customElements.get('cart-drawer-items');
    if (Items && !Items.prototype.__vcdPatched) {
      Items.prototype.getSectionsToRender = function () {
        return [
          { id: 'CartDrawer', section: SECTION_ID, selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];
      };
      // 수량 변경/삭제: line 번호 대신 라인 키(id)로 처리 — 사은품 자동 담기/빼기로 줄 순서가 바뀌어도 안전
      Items.prototype.updateQuantity = function (line, quantity, name) {
        var self = this;
        var li = document.getElementById('CartDrawer-Item-' + line) || document.getElementById('CartItem-' + line);
        var key = li && li.dataset.key;
        var input = document.getElementById('Drawer-quantity-' + line) || document.getElementById('Quantity-' + line);
        var variantId = input && input.dataset.quantityVariantId;
        var oldQty = li ? (parseInt(li.dataset.quantity, 10) || 0) : 0;
        var beforeTotal = 0;
        if (variantId) {
          $$('.vcd__item').forEach(function (el) {
            var inp = el.querySelector('.vcd__qty-input');
            var vid = inp ? inp.dataset.quantityVariantId : (el.dataset.variantId || '');
            if (String(vid) === String(variantId)) beforeTotal += parseInt(el.dataset.quantity, 10) || 0;
          });
        }
        var sectionsToRender = this.getSectionsToRender();
        if (typeof this.enableLoading === 'function') this.enableLoading(line);
        var sectionNames = sectionsToRender.map(function (s) { return s.section; });
        var keys = (li && li.dataset.keys) ? li.dataset.keys.split(',') : (key ? [key] : []);
        var endpoint, body;
        if (keys.length > 1) {
          // 합쳐진 줄: 첫 줄에 총수량을 몰고 나머지 줄은 0 으로 (한 번의 update 요청)
          var updates = {};
          keys.forEach(function (k, i) { updates[k] = i === 0 ? quantity : 0; });
          endpoint = ROOT + 'cart/update.js';
          body = { updates: updates, sections: sectionNames, sections_url: window.location.pathname };
        } else {
          endpoint = ROOT + 'cart/change.js';
          body = { quantity: quantity, sections: sectionNames, sections_url: window.location.pathname };
          if (key) body.id = key; else body.line = line;
        }
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.errors) {
              if (input) input.value = input.getAttribute('value');
              self.updateLiveRegions(line, state.errors);
              return;
            }
            var d = drawer();
            if (d) d.classList.toggle('is-empty', state.item_count === 0);
            self.classList.toggle('is-empty', state.item_count === 0);
            sectionsToRender.forEach(function (s) {
              var host = document.getElementById(s.id);
              var el = host && (host.querySelector(s.selector) || host);
              if (el && state.sections && state.sections[s.section]) el.innerHTML = sectionInner(state.sections[s.section], s.selector);
            });
            // 검증: 같은 상품(variant)의 총 수량이 기대만큼 바뀌었는지로 판단
            // (Shopify 가 자동 할인 때문에 줄을 쪼개거나 합쳐도 오탐하지 않도록)
            var msg = '';
            if (quantity > 0 && variantId) {
              var afterTotal = 0;
              for (var i = 0; i < state.items.length; i++) { if (String(state.items[i].variant_id) === String(variantId)) afterTotal += state.items[i].quantity; }
              var expected = beforeTotal + (quantity - oldQty);
              if (afterTotal !== expected) {
                msg = afterTotal < expected
                  ? ((window.cartStrings && window.cartStrings.quantityError) || '').replace('[quantity]', afterTotal)
                  : ((window.cartStrings && window.cartStrings.error) || '');
              }
            }
            if (msg) self.updateLiveRegions(line, msg);
            if (d && typeof d.checkForClear === 'function') d.checkForClear();
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId: input && input.dataset.quantityVariantId });
            }
          })
          .catch(function () {
            var errs = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
            if (errs) errs.textContent = (window.cartStrings && window.cartStrings.error) || '';
          })
          .finally(function () { if (typeof self.disableLoading === 'function') self.disableLoading(line); });
      };
      // Shrine 원본 updateCart 는 'cart-drawer' 섹션을 하드코딩해서 요청하므로 통째로 교체
      Items.prototype.updateCart = function () {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {}, sections: [SECTION_ID, 'cart-icon-bubble'], sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            var d = drawer();
            if (d && typeof d.renderContents === 'function') d.renderContents(state, true);
          })
          .catch(function (e) { console.error(e); });
      };
      Items.prototype.__vcdPatched = true;
    }
  }

  function boot() {
    // 테마 스크립트(defer)가 먼저 정의할 시간을 준 뒤 fallback 판단
    setTimeout(defineFallback, 0);
    customElements.whenDefined('cart-drawer').then(patchThemeClasses);
    customElements.whenDefined('cart-drawer-items').then(patchThemeClasses);
    init();
    observe();
    window.vcdRefresh = refreshDrawer;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
